'use strict'

export const slider = (() => {
    const init = () => {
        const sliders = document.querySelectorAll('.slider')

        if (sliders.length) {
            sliders.forEach(slider => {
                const track = slider.querySelector('.slider-track')
                const paginateLeft = slider.querySelector('.left')
                const paginateRight = slider.querySelector('.right')
                const slideWidth = parseInt(slider.dataset.sliderStep)
                let position = 0
        
                const updateButtons = () => {
                    paginateLeft.classList.toggle('hidden', position === 0)
                    paginateRight.classList.toggle('hidden', position <= -(track.scrollWidth - track.clientWidth))
                }
        
                paginateRight.addEventListener('click', () => {
                    position -= slideWidth
                    track.style.transform = `translateX(${position}px)`
                    updateButtons()
                })
        
                paginateLeft.addEventListener('click', () => {
                    position += slideWidth
                    track.style.transform = `translateX(${position}px)`
                    updateButtons()
                })
        
                updateButtons()
            })
        }
    }

    return {
        init
    }
})()
